<template>
  <DashboardCard
    v-if="affiliateInfo"
    ref="dashboardCard"
    :noPadding="checkMobile(768)"
    :class="['mb-3 w-100 auto-h', { 'mr-2': !checkMobile(768) }]"
  >
    <div class="d-flex align-items-center justify-content-center" v-if="activeLoad">
      <Loader :visible="activeLoad"></Loader></div>
    <img src="@/assets/note_check.svg" slot="icon" class="card-icon" />
    <span slot="title"> Histórico de peças geradas</span>

    <section class="wrapper-history-table-desk" v-show="!activeLoad" v-if="!checkMobile(768)">
      <table class="campaign-format-table">
        <thead>
          <th v-for="(title ,index ) in titles"
            :key="index" :class="'th-'+title.class">
            {{title.name}}
          </th>
        </thead>
        <tbody>
          <tr v-for="(item, index) in items" :key="index">
            <td>
              <span>
                {{ dateFormatter(item.created_at)}}
              </span>
            </td>
            <td>
              <img :src="getImgUrl(item.campaign_format_code)"
                :alt="'Image '+item.campaign_format_code" width="22">
              <span>
                {{ emptyFieldFormatter(item.campaign_format_code) }}
              </span>
            </td>
            <td>
              <span
                v-if="item.campaign_name.split(',').length > 1"
                v-b-popover.hover.right="{
                  customClass: 'custom-info-popover',
                  content: item.campaign_name,
                }"
              >
                {{ formatterCategory(item.campaign_name) }}
              </span>
              <span
                v-else
                >
                {{ emptyFieldFormatter(item.campaign_name) }}
              </span>
            </td>
            <td class="td-content">
              <span>
                {{ emptyFieldFormatter(item.description) }}
              </span>
            </td>
            <td class="td-label">
              <span>
                {{ emptyFieldFormatter(item.des_label) }}
              </span>
            </td>
            <td class="td-site">
              <span>
                {{ textFormatter(item.des_url, 30) }}
              </span>
            </td>
            <td>
              <CopyButton
                  :copyValue="item.content"
                  :disabled="item.expired == 0 ? false : true"
                />
            </td>
          </tr>
        </tbody>
      </table>
    </section>
    <section class="wrapper-history-table-mobile" v-show="!activeLoad" v-else>
      <table class="campaign-format-table-mobile">
        <thead>
          <th class="th-table-mobile-format">Formato</th>
          <th class="th-table-mobile-campaign">Campanha</th>
        </thead>
        <tbody>
          <template  v-for="(item, index) in items">
            <tr :key="index">
              <td class="td-campaign-format-mobile">
                <span>
                  {{ emptyFieldFormatter(item.campaign_format_code) }}
                </span>
              </td>
              <td class="td-campaign-name-mobile">
                <span>
                  {{ textFormatter(item.campaign_name, 15) }}
                </span>
                <a block v-b-toggle="'accordion-'+ index"
                  class="button-mobile-arrows">
                </a>
              </td>
            </tr>
            <tr :key="'tr-'+ index">
              <td colspan="2" class="td-wrapper-mobile-contents">
                <b-collapse :id="'accordion-'+index"
                   role="tabpanel">
                  <div class="wrapper-mobile-contents  p-3">
                    <div class="mobile-content">
                      <div class="mobile-d-content date-content">
                        <strong>Data</strong>
                        <span>{{ dateFormatter(item.created_at)}}</span>
                      </div>
                      <div class="mobile-d-content content-content">
                        <strong>Conteúdo</strong>
                        <span>{{ emptyFieldFormatter(textFormatter(item.description, 20)) }}</span>
                      </div>
                      <div class="mobile-d-content label-content">
                        <strong>Identificador</strong>
                        <span> {{ emptyFieldFormatter(textFormatter(item.des_label, 12)) }} </span>
                      </div>
                    </div>
                    <div  class="mobile-d-content mobile-content">
                      <div class="mobile-d-content site-content">
                        <strong>Site</strong>
                        <span> {{ textFormatter(item.des_url, 30) }} </span>
                      </div>
                      <div class="mobile-d-content action-content">
                        <CopyButton
                            :copyValue="item.content"
                            :disabled="item.expired == 0 ? false : true"
                          />
                      </div>
                    </div>
                  </div>
                </b-collapse>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </section>

    <div
      class="no-history"
      v-if="campaignFormatHistory.length == 0 && !activeLoad"
    >
      <span class="text-neutral">Nenhuma peça encontrada.</span>
    </div>
    <div
      class="ver-mais"
      v-if="
        campaignFormatHistory.length > MAX_ITEMS &&
        !activeLoad && !showMoreItems
      "
      @click="showMore(); track(`historico_${this.advertiser.code}`, 'clicou_ver_mais_pecas_geradas');"
    >
      <a class="ver-mais-button"> Ver mais peças geradas </a>
    </div>
  </DashboardCard>
</template>

<script>
import { mapGetters } from 'vuex';
import HistoryApi from '@/services/history';
import DashboardCard from '@/components/DashboardCard';
import Loader from '@/components/Loader';
import CopyButton from '@/components/utils/CopyButton';
import { getStringFromDate } from '@/utils/dateUtils';
import { truncateString } from '@/utils/stringUtils';

export default {
  name: 'CampaignFormatHistoryCard',
  props: ['advertiser'],
  components: {
    DashboardCard,
    Loader,
    CopyButton,
  },
  data() {
    return {
      MAX_ITEMS: 5,
      showMoreItems: false,
      titles: [
        {
          name: 'Data',
          class: 'date',
        },
        {
          name: 'Formatos',
          class: 'format',
        },
        {
          name: 'Categoria',
          class: 'category',
        },
        {
          name: 'Conteúdo',
          class: 'content',
        },
        {
          name: 'indentificadores',
          class: 'label',
        },
        {
          name: 'Site',
          class: 'site',
        },
        {
          name: 'Ação',
          class: 'action',
        },
      ],
      options: undefined,
      campaignFormatHistory: [],
      items: [],
      activeLoad: true,
    };
  },
  created() {
    this.loadAffiliateInfo();
  },
  computed: {
    ...mapGetters(['affiliateInfo']),
    loadedAffiliateInfo() {
      return this.affiliateInfo !== null;
    },
  },
  methods: {
    loadAffiliateInfo() {
      const self = this;
      (function waitForAffiliateInfo() {
        setTimeout(async () => {
          if (!self.loadedAffiliateInfo) {
            waitForAffiliateInfo();
          } else {
            await self.loadValues();
          }
        }, 100);
      }());
    },
    async loadValues() {
      this.options = {
        idtPerson: this.affiliateInfo.idtPerson,
        idtProductSource: this.advertiser.id,
      };
      this.campaignFormatHistory = await HistoryApi.getHistoryList(
        this.options,
      );
      if (this.campaignFormatHistory !== undefined) {
        if (this.campaignFormatHistory.length > this.MAX_ITEMS) {
          this.items = this.campaignFormatHistory.slice(0, this.MAX_ITEMS);
        } else {
          this.items = this.campaignFormatHistory;
        }
      }
      this.activeLoad = false;
    },
    showMore() {
      this.items = this.campaignFormatHistory;
      this.showMoreItems = true;
    },
    dateFormatter(value) {
      return getStringFromDate(new Date(value));
    },
    textFormatter(title, size) {
      return truncateString(title, size);
    },
    formatterCategory(category) {
      const categoryArray = category.split(',');
      return `${categoryArray[0]}...`;
    },
    emptyFieldFormatter(value) {
      if (
        value !== null
        && value !== undefined
        && value !== ''
        && value !== 'null'
      ) {
        return value;
      }
      return '——';
    },
    checkMobile(size) {
      return window.innerWidth <= size;
    },
    getImgUrl(ext) {
      const images = require.context('@/assets/campaign_format/', false, /\.(png|jpe?g|svg)$/);
      const extensions = ['links', 'banner', 'e-mail'];
      const newExt = ext.split(' ');
      if (extensions.indexOf(newExt[0].toLowerCase()) !== -1) {
        return images(`./${newExt[0].toLowerCase()}.svg`);
      }
      return images('./banner.svg');
    },
  },
};
</script>

<style lang="scss" scoped>
.auto-h {
  height: inherit !important;
}

.ver-mais {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 38px;
  margin: 10px 0;

  .ver-mais-button {
    border: 1px solid $denim;
    color: $denim;
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 70px;
    height: 38px;
    @include text-size-regular();
    cursor: pointer;
    &:hover {
      color: #1082BE;
      text-decoration: underline;
    }
  }

  @media screen and (max-width: 576px) {
    .ver-mais-button {
      padding: 0 50px;
    }
  }
}

.campaign-format-table {
  width: 100%;
  padding: 10px 0px;

  th {
    padding: 5px 5px 8px 5px;
    border-bottom: solid 1px #CDCDCD;
    @include text-size-small();
    font-family: $font-1;

    &.th-action{
      padding: 5px 5px 8px 10px;
    }
  }

  tbody {
    padding-top: 10px;

    td {
      padding: 5px;
      font-family: $font-1;
      @include text-size-small();
    }
  }
}

.campaign-format-table-mobile {
  width: 100%;
  padding: 10px 0px;

  th {
    border-bottom: solid 1px #CDCDCD;
    font-size: 14px;
    font-family: $font-1;

    &.th-table-mobile-format{
      padding-top: 5px;
      padding-bottom: 8px;
      padding-left: 1rem;
    }

    &.th-table-mobile-campaign{
      padding-top: 5px;
      padding-bottom: 8px;
      padding-right: 1rem;
    }
  }

  tbody {
    td {
      font-family: $font-1;
      font-size: 14px;
      &.td-wrapper-mobile-contents {
        padding: 0;
      }
    }
  }
  .wrapper-mobile-contents {
    display: flex;
    flex-direction: column;
    background-color: $wild-sand;
    padding: 5px;

    .mobile-content {
      display: flex;
      justify-content: space-between;
      padding: 5px 0;

      .mobile-d-content {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;

        span, strong {
          font-family: $font-1;
          font-size: 12px;
        }
      }
      .action-content {
        align-items: center;
        justify-content: center;
      }
    }
  }
}

.td-campaign-format-mobile {
  padding-left: 1rem;
  padding-top: 5px;
  padding-bottom: 5px;
}

.td-campaign-name-mobile {
  display: flex;
  justify-content: space-between;
  padding-right: 1rem;
  padding-top: 5px;
  padding-bottom: 5px;
  .button-mobile-arrows {
    width: 30px;
    display: flex;
    justify-content: center;
    &[aria-expanded="true"]{
      content: url('~@/assets/arrows/arrow-up.svg');
      width: 15px;
    }
    &[aria-expanded="false"]{
      content: url('~@/assets/arrows/arrow-down.svg');
      width: 15px;
    }
  }
}

.td-content, .td-label, .td-site{
  line-height: 15px;
}

.th-content{
  width: 25%;
}

.img-icon-format {
  margin-right: 4px;
}

.no-history {
  display: flex;
  height: 80px;
  align-items: center;
  justify-content: center;
}

/deep/ {
  .icon {
    display: flex;
    @media screen and (max-width: $lg) {
      padding-top: 8px;
    }
  }
}
</style>
